import type { IconObject } from '@/dsComponents/buttons/types';

export const getIconClasses = (icon: string | IconObject) => {
	if (typeof icon === 'string') {
		return ['ti', `ti-${icon}`];
	}
	if (icon.color) {
		return ['ti', `ti-${icon.icon}`, icon.color];
	}
	return ['ti', `ti-${icon.icon}`];
};
